<template>
  <h1 class="text-center">Animated Pages</h1>

</template>

<script>
export default {
  name: "AnimatedPages"
}
</script>

<style scoped>

</style>